export const MIN_EDIT_FREE_VISITS_COUNT = 0;
export const MIN_FREE_VISITS_COUNT = 1;
export const MAX_FREE_VISITS_COUNT = 9999;
export const FREE_VISITS_STEP = 1;
